
/* eslint-disable */
const Validation = {
  checkPhone, // 检测是否为电话号码
  isEmpty, // 是否为空
  isNumber, // 是否为数字
  checkLength, // 检测字符串长度
  isEqual, // 是否相同
  replaceStr, // *替换str
  checkPwd, // 检测密码格式 6-16位数字或字母
  checkPwd2, // 检测密码格式 6-16位数字和字母
  checkArrLen, // 检测数组长度是否存在
  isIdcard, // 检测身份证是否合法
  isTel, // 检测电话号码（包括座机号和手机号）
  isChina, // 检测是否为中文
  isSpecial, // 判断是否包含特殊字符
  isFeePoint,  // 判断最多小数点后6位
  isInteger, // 是否是正整数
  checkEmoji, // 是否含有emoji表情
  validatePrice, // 金额校验
  validateDiscount, // 折扣校验
  contactEmail// 邮件正则
}

function checkPhone (num) {
  // 表示以1开头，第二位可能是3/4/5/7/8等的任意一个，在加上后面的\d表示数字[0-9]的9位，总共加起来11位结束。
  if ((/^1\d{10}$/.test(num))) { // 判断条件:不是正确的手机号码
    return false
  } else {
    return true
  }
}

/**
 * 是否是正整数
 * @param str
 * @returns {boolean}
 */
function isInteger (str) {
  str = str || ''
  if (/^\+?[1-9]\d*$/.test(str)) { // 为空，返回true
    return true
  } else {
    return false
  }
}

function isEmpty (str) {
  str = str || ''
  if (/^\s*$/.test(str)) { // 为空，返回true
    return true
  } else {
    return false
  }
}

function isNumber (str) { // 是数字 为true
  str = str || 0
  if (/^\d+(\.\d+)?$/.test(str)) {　
    return true
  } else {
    return false
  }
}

function isTel (str) { // 是电话号码 为true（数字和——）
  str = str || ''
  if (/^(((\d{3,4}-?)?\d{7,8})|(1\d{10}))$/.test(str)) {
    return true
  } else {
    return false
  }
}

function isChina (str) {
  str = str.replace(/[\u4e00-\u9fa5]+/g, '')
  return str
}

function isSpecial (val) {
  val = val.trim() || ''
  var regEn = /[`~!@#$%^&*()_+<>?"{}.\/'[\]·！#￥（——）；|《》？、【】[\]️ ♂️♀️]/im
  if (regEn.test(val)) {
    return false
  } else {
    return true
  }
}

/**
 * 小数点后最多6位
 * @param val
 * @returns {boolean}
 */
function isFeePoint(val) {
  var reg = /^[+-]?\d+(\.\d{1,6})?$/
  if(reg.test(val)) {
    return true
  }else {
    return false
  }
}


function checkLength (str, len) { // 超出了，返回true
  str = str.trim() || ''
  if (str.length > len) {
    return true
  } else {
    return false
  }
}

function isEqual (str1, str2) { // 不相同，返回true
  str1 = str1 || ''
  str2 = str2 || ''
  if (str1 === str2) {
    return false
  } else {
    return true
  }
}

function repeatStr (str, count) {
  var text = ''
  for (var i = 0; i < count; i++) {
    text += str
  }
  return text
}

function replaceStr (str, regArr, type, ARepText) { // demo:replaceStr('18819322663',[3,5,3],0)
  var regtext = '',
    Reg = null,
    replaceText = ARepText || '*'
  if (regArr.length === 3 && type === 0) {
    regtext = '(\\w{' + regArr[0] + '})\\w{' + regArr[1] + '}(\\w{' + regArr[2] + '})'
    Reg = new RegExp(regtext)
    var replaceCount = repeatStr(replaceText, regArr[1])
    return str.replace(Reg, '$1' + replaceCount + '$2')
  }
}

function checkPwd (str) {
  str = str || ''
  if (/^[a-zA-Z0-9]{6,16}$/.test(str)) {
    return false
  } else {
    return true
  }
}

function checkPwd2 (str) {
  str = str || ''
  if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(str)) {
    return false
  } else {
    return true
  }
}

function checkArrLen (arr) {
  arr = arr || []
  if (arr.length < 1) { return false } else { return true }
}
function isIdcard (ID) {
  if (typeof ID !== 'string') return '非法字符串'
  var city = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江 ', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北 ', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏 ', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外' }
  var birthday = ID.substr(6, 4) + '/' + Number(ID.substr(10, 2)) + '/' + Number(ID.substr(12, 2))
  var d = new Date(birthday)
  var newBirthday = d.getFullYear() + '/' + Number(d.getMonth() + 1) + '/' + Number(d.getDate())
  var currentTime = new Date().getTime()
  var time = d.getTime()
  var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
  var sum = 0
  var i
  var residue

  if (!/^\d{17}(\d|x)$/i.test(ID)) return false
  if (city[ID.substr(0, 2)] === undefined) return false
  if (time >= currentTime || birthday !== newBirthday) return false
  for (i = 0; i < 17; i++) {
    sum += ID.substr(i, 1) * arrInt[i]
  }
  residue = arrCh[sum % 11]
  if (residue !== ID.substr(17, 1).toUpperCase()) return false

  return true
}

/**
 * 检验是否有输入法表情
 * @param val {string} 
 * @returns {boolean} 含有表情则会返回true
 */
function checkEmoji (val) {
  return /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g.test(val)
}

/**
 * 金额校验，0.01 - 100000
 * @param str
 * @returns {string}
 */
function validatePrice (str) {
  console.log(str)
  let reg = /^[1-9]\d{0,4}(\.\d{0,2})?$|^0(\.\d{0,2})?$|^100000$/
  return reg.test(str)
}

/**
 * 折扣校验，0.1 - 9.9
 * @param str
 * @returns {string}
 */
function validateDiscount (str) {
  console.log(str)
  let reg = /^[0-9](\.[1-9]{0,1})?$/
  return reg.test(str)
}

/**
 * @function: 邮箱正则
 * @param {str}
 */
export function contactEmail (str) {
  const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
  return reg.test(str)
}

export default Validation
